import { DisplayColumnMap } from 'types/model/display-column-map';

export const FP_LOCAL_STORAGE_KEY = 'fp_display_column_map_';
const RETURN_URL_KEY = 'returnUrl';

export const getLocalStorageDisplayColumnMap = (searchCriteriaId: string) => JSON.parse(localStorage.getItem(FP_LOCAL_STORAGE_KEY + searchCriteriaId) as string) as DisplayColumnMap || {};
export const setLocalStorageDisplayColumnMap = (searchCriteriaId: string, displayColumnMap: DisplayColumnMap) => localStorage.setItem(FP_LOCAL_STORAGE_KEY + searchCriteriaId, JSON.stringify(displayColumnMap));

/**
 * 戻り先URLの相対パスを取得する
 * @returns 相対パス
 */
export const getLocalStorageReturnUrl = (): string | null => window.localStorage.getItem(RETURN_URL_KEY);
/**
 * URLの相対パスをLocalStorageに保存する
 * @param url 相対パス
 */
export const setLocalStorageReturnUrl = (url: string): void => window.localStorage.setItem(RETURN_URL_KEY, url);
export const removeLocalStorageReturnUrl = (): void => window.localStorage.removeItem(RETURN_URL_KEY);
